import './style.scss'

import React, { Component } from 'react'

import AppPortal from 'components/UI/AppPortal'
import Icon from 'components/UI/Icon'
import Overlay from 'components/UI/Overlay'
import PropTypes from 'prop-types'
import cancelIcon from 'img/cancel.svg'
import { modalOpen, modalClose } from 'utilities/modal'
import classNames from 'classnames'

class Modal extends Component {
    componentWillMount() {
        modalOpen()
    }

    handleKeyDown(e) {
        if (e.key === 'Escape') {
            this.closeModal(e)
        }
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown)
    }

    componentWillUnmount() {
        modalClose()
        document.removeEventListener('keydown', this.handleKeyDown)
    }

    handleClose() {
        if (this.props.onClose) {
            this.props.onClose()
        }
    }
    render() {
        const { children, show, className } = this.props
        if (!show) return null
        const classes = classNames({
            modal: true,
            [className]: className,
        })
        return (
            <AppPortal>
                <Overlay onClick={() => this.handleClose()}>
                    <div className={classes} onClick={(e) => e.stopPropagation()}>
                        <Icon
                            svg={cancelIcon}
                            className="modal__exit"
                            onClick={() => this.handleClose()}
                        />
                        {children}
                    </div>
                </Overlay>
            </AppPortal>
        )
    }
}

Modal.propTypes = {
    onClose: PropTypes.func,
    children: PropTypes.node,
    show: PropTypes.bool,
    className: PropTypes.string,
}

export default Modal
